// Pull-to-refresh: потянуть список вниз у верхнего края — обновить.
// Заменяет ручную кнопку «🔄». Жест активен только когда страница
// прокручена в самый верх.

import { ReactNode, useRef, useState } from "react";

const THRESHOLD = 70;

export function PullToRefresh({
  onRefresh,
  children,
}: {
  onRefresh: () => Promise<void> | void;
  children: ReactNode;
}) {
  const [pull, setPull] = useState(0);
  const [refreshing, setRefreshing] = useState(false);
  const startY = useRef<number | null>(null);

  const onTouchStart = (e: React.TouchEvent) => {
    if (window.scrollY <= 0 && !refreshing) {
      startY.current = e.touches[0].clientY;
    }
  };

  const onTouchMove = (e: React.TouchEvent) => {
    if (startY.current == null || refreshing) return;
    const dy = e.touches[0].clientY - startY.current;
    if (dy > 0 && window.scrollY <= 0) {
      setPull(Math.min(dy * 0.5, THRESHOLD + 24));
    } else {
      setPull(0);
    }
  };

  const onTouchEnd = async () => {
    if (startY.current == null) return;
    const reached = pull >= THRESHOLD;
    startY.current = null;
    if (reached && !refreshing) {
      setRefreshing(true);
      setPull(THRESHOLD);
      try {
        await onRefresh();
      } finally {
        setRefreshing(false);
        setPull(0);
      }
    } else {
      setPull(0);
    }
  };

  return (
    <div
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
    >
      <div
        className="flex items-end justify-center overflow-hidden text-tg-hint"
        style={{
          height: pull,
          transition: startY.current == null ? "height 0.2s" : undefined,
        }}
      >
        <div
          className={
            "w-6 h-6 mb-2 rounded-full border-2 border-tg-secondaryBg " +
            "border-t-tg-accentText " +
            (refreshing ? "animate-spin" : "")
          }
          style={{
            opacity: Math.min(pull / THRESHOLD, 1),
            transform: refreshing
              ? undefined
              : `rotate(${pull * 3}deg)`,
          }}
        />
      </div>
      {children}
    </div>
  );
}
